import {TscStyles, TscThemeName, TscThemeNames} from '@techsmith/tsc-cloud-style-guide';
import styled from 'styled-components';
import React from 'react';
import CssUtil from '../../util/CssUtil';
import {t} from 'i18next';
import config from '../../service/config';

const Container = styled.div<{theme: TscThemeNames}>`
   margin: 0 0 1rem 0;
   padding: 1rem;
   background-color: ${props => props.theme === TscThemeName.dawn ? TscStyles.color.ui.dawn.lightMedium : TscStyles.color.ui.dusk.medium};
   border-radius: ${TscStyles.border.radius.lg};
`;

const Title = styled.h3<{hasDescription: boolean}>`
   margin: 0;
   font-size: 1.25rem;
   font-weight: 600;
   line-height: 1.5rem;
   display: flex;
   align-items: center;
   ${props => !props.hasDescription && 'margin-bottom: 1rem;'}
`;

const Description = styled.div`
   font-style: italic;
   font-size: smaller;
   margin: .25rem 0 1rem 0;
`;

export const SettingsGroupProIcon = styled.span<{theme: TscThemeNames}>`
   padding: 0 .5rem;
   border-radius: ${TscStyles.border.radius.xl};
   font-size: 1rem;
   color: ${TscStyles.color.text.mediumDark};
   font-weight: 600;
   margin-left: 0.5rem;
   background: linear-gradient(90deg, ${CssUtil.toRgba(TscStyles.color.action.screencastPrimaryStop1, 1)}, ${CssUtil.toRgba(TscStyles.color.action.screencastPrimaryStop2, 1)});

   > a {
      text-decoration: none;
      color: inherit;
   }
`;

const SettingsGroup: React.FC<IProps> = ({theme, showProIcon = false, title, description, children}) => (
   <Container theme={theme}>
      <Title hasDescription={!!description}>
         {title}
         {showProIcon && (
            <SettingsGroupProIcon theme={theme}>
               <a
                  target="_blank"
                  href={config.environmentData.ScreencastProPurchaseLinkUrl}
                  rel="noreferrer"
               >
                  {t('screencastTierPlanLabels.pro')}
               </a>
            </SettingsGroupProIcon>
         )}
      </Title>
      <Description>
         {description}
      </Description>
      {children}
   </Container>
);

interface IProps {
   theme: TscThemeNames;
   title: string;
   showProIcon?: boolean;
   description?: string;
   children?: React.ReactNode | React.ReactNode[];
}

export default SettingsGroup;
